<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" (click)="closed.emit()">
  <div
    class="bg-base-100 rounded-lg shadow-xl w-full max-w-xl max-h-[90vh] flex flex-col"
    (click)="$event.stopPropagation()"
  >
    <div class="flex items-start justify-between gap-3 p-4 border-b border-base-300">
      <div>
        <div class="font-semibold">Versandzeitpunkt</div>
        <div class="text-sm opacity-70 mt-0.5">
          {{ isStaging() ? "Staging-Versand" : "Standardversand" }}
        </div>
      </div>
      <button type="button" class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closed.emit()">Schließen</button>
    </div>

    <div class="flex-1 overflow-y-auto p-4 flex flex-col gap-3">
      <!-- Modus-Auswahl -->
      <div class="flex gap-1 flex-wrap">
        <button
          type="button"
          class="bm-btn bm-btn-sm"
          [class.bm-btn-primary]="mode() === 'offset'"
          (click)="mode.set('offset')"
        >
          {{ wording().mode }}
        </button>
        <button
          type="button"
          class="bm-btn bm-btn-sm"
          [class.bm-btn-primary]="mode() === 'date'"
          (click)="mode.set('date')"
        >
          Datum
        </button>
        @if (isStaging()) {
          <button
            type="button"
            class="bm-btn bm-btn-sm"
            [class.bm-btn-primary]="mode() === 'kw'"
            (click)="mode.set('kw')"
          >
            KW-Zuordnung
          </button>
        }

        <!-- Eilfall: heute raus, Express. Nur sichtbar, solange die
             Geschwindigkeit überhaupt noch änderbar ist. -->
        @if (speedEditable()) {
          <button
            type="button"
            class="bm-btn bm-btn-sm bm-btn-error ml-auto"
            title="Setzt den Termin auf heute und die Geschwindigkeit auf Express"
            (click)="setExpressToday()"
          >
            Expressversand heute!
          </button>
        }
      </div>

      @if (mode() === "offset") {
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Spätestens</label>
          <label class="bm-input">
            <input
              type="number"
              class="w-16 shrink-0"
              min="0"
              max="365"
              [ngModel]="latestOffsetDays()"
              (ngModelChange)="setLatestOffsetDays($event)"
            />
            <span class="bm-label truncate">{{ wording().unit }}</span>
          </label>

          @if (windowAllowed()) {
            <label class="bm-fieldset-label mt-2 flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                class="bm-checkbox bm-checkbox-sm"
                [ngModel]="allowEarlier()"
                (ngModelChange)="allowEarlier.set($event)"
              />
              <span>Schon früher versenden erlaubt</span>
            </label>

            @if (allowEarlier()) {
              <label class="bm-fieldset-label">Frühestens</label>
              <label class="bm-input">
                <input
                  type="number"
                  class="w-16 shrink-0"
                  min="0"
                  max="365"
                  [ngModel]="earliestOffsetDays()"
                  (ngModelChange)="setEarliestOffsetDays($event)"
                />
                <span class="bm-label truncate">{{ wording().unit }}</span>
              </label>
              @if (windowInvalid()) {
                <span class="text-xs text-error mt-1">
                  „Frühestens" muss mindestens so viele Werktage vor dem Auftrag liegen wie „spätestens" — mehr
                  Werktage vorher heißt früherer Tag.
                </span>
              } @else {
                <span class="text-xs opacity-60 mt-1">
                  Das Lager darf an jedem Tag im Zeitraum versenden, zum Beispiel gebündelt im Sammelversand.
                </span>
              }
            }
          } @else if (!isStaging()) {
            <span class="text-xs opacity-60 mt-1">
              Bei PickPoint taktet der Abholtermin den Versand — ein Abhol-Zeitraum über mehrere Tage ist hier nicht
              wählbar.
            </span>
          }
        </fieldset>
      } @else if (mode() === "date") {
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Fester Termin</label>
          <div class="flex gap-1 flex-wrap mb-1">
            <button type="button" class="bm-btn bm-btn-xs" (click)="setToday()">Heute</button>
            <button type="button" class="bm-btn bm-btn-xs" (click)="setTomorrow()">Morgen</button>
          </div>
          <input
            class="bm-input w-full"
            type="date"
            [ngModel]="fixedDate()"
            (ngModelChange)="fixedDate.set($event || '')"
          />
          @if (isStaging()) {
            <span class="text-xs opacity-60 mt-1">
              Die Pakete dürfen an diesem Tag ab 09:00 Uhr losgeschickt werden.
            </span>
          }
        </fieldset>
      } @else {
        <div class="bm-alert bm-alert-info bm-alert-soft text-sm">
          <fa-icon [icon]="iconInfo" />
          <span>
            Der Staging-Versand richtet sich nach der Kalenderwoche aus der Staging-Zuordnung
            @if (stagingKw()) {
              (aktuell <strong>KW {{ stagingKw() }}</strong>)
            }
            — kein eigener Termin.
          </span>
        </div>
      }

      <!-- Paket-Geschwindigkeit: bewusst auch hier, weil sie die Laufzeit bestimmt -->
      @if (config().shipment_method === "parcel") {
        <fieldset class="bm-fieldset">
          <label class="bm-fieldset-label">Paket-Geschwindigkeit</label>
          <div class="flex gap-1 flex-wrap">
            @for (speed of speeds; track speed.value) {
              <button
                type="button"
                class="bm-btn bm-btn-sm"
                [class.bm-btn-primary]="packageSpeed() === speed.value"
                [disabled]="!speedEditable()"
                (click)="packageSpeed.set(speed.value)"
              >
                <fa-icon [icon]="speed.icon" class="mr-1" />{{ speed.label }}
              </button>
            }
          </div>
          @if (!speedEditable()) {
            <span class="text-xs opacity-60 mt-1">
              Dieser Kanal ist bereits versandt — die Geschwindigkeit ist eingefroren.
            </span>
          } @else if (config().versand_shipped || config().staging_shipped) {
            <span class="text-xs opacity-60 mt-1">
              Gilt für die noch offene Sendung; die bereits versandte bleibt davon unberührt.
            </span>
          }
        </fieldset>
      }

      <!-- Vorschau -->
      <div class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
        <div class="bm-card-title text-sm">Voraussichtlich</div>
        @if (mode() === "kw") {
          <div class="text-sm opacity-70">
            Kein fester Termin — der Versand folgt der Kalenderwoche der Staging-Zuordnung.
          </div>
        } @else {
          <dl class="bm-dl gap-x-2 text-sm">
            <dt>{{ earliestDay() ? "Versand zwischen" : "Versand am" }}</dt>
            <dd>
              @if (earliestDay()) {
                {{ formatDay(earliestDay()) }} und {{ formatDay(shipDay()) }}
              } @else {
                {{ formatDay(shipDay()) }}
              }
            </dd>

            <dt>Ankunft</dt>
            <dd>
              @if (arrivalDay()) {
                {{ formatDay(arrivalDay()) }}
                <span class="opacity-60">({{ transitDays() }} Werktage Laufzeit)</span>
              } @else {
                <span class="opacity-60">keine Angabe für diese Versandart</span>
              }
            </dd>
          </dl>

          @if (arrivalTooLate()) {
            <div class="bm-alert bm-alert-warning bm-alert-soft text-xs mt-1">
              Die Ankunft liegt nach dem Auftragstermin — das Material wäre zu spät vor Ort.
            </div>
          }
        }
      </div>

      @if (errorMessage(); as error) {
        <div class="bm-alert bm-alert-error bm-alert-soft text-sm">{{ error }}</div>
      }
    </div>

    <div class="flex justify-end gap-2 p-4 border-t border-base-300">
      <button type="button" class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closed.emit()">Abbrechen</button>
      <button type="button" class="bm-btn bm-btn-primary bm-btn-sm" [disabled]="!canSave()" (click)="onSave()">
        {{ saving() ? "Speichere …" : "Speichern" }}
      </button>
    </div>
  </div>
</div>
